<template>
  <section class="su-career-guidance">
    <div class="su-title">
      <p>профориентация</p>
      <h2>
        в школьном университете <span>профориентация</span> — неотъемлемая
        часть процесса <span>в&nbsp;течение всего обучения</span>&nbsp;ребенка
      </h2>
    </div>

    <div class="su-career-guidance__content">
      <div class="su-career-guidance__block block block-1">
        <p class="block__title">
          <span>1.</span> изучаем личность ребенка
        </p>

        <p class="block-1__small">
          начните свой путь <br> с
          <button
            class="m-btn"
            @click="scrollTo('.su-tests')"
          >
            экспресс-теста
          </button>
        </p>
      </div>
      <div class="su-career-guidance__block block block-2">
        <p class="block__title">
          <span>2.</span> строим карту интересов
        </p>
      </div>
      <div class="su-career-guidance__block block block-3">
        <p class="block__title">
          <span>3.</span> знакомим ребенка с&nbsp;профессиями из&nbsp;подходящих сфер
        </p>
      </div>
      <div class="su-career-guidance__block block block-4">
        <p class="block__title">
          <span>4.</span> формируем список «избранных профессий», которые наиболее подходят ребенку
        </p>
      </div>
      <div class="su-career-guidance__block block block-5">
        <p class="block__title">
          <span>5.</span>
          строим полноценную стратегию получения знаний и&nbsp;навыков для&nbsp;профессии
        </p>
      </div>
      <div class="su-career-guidance__block block block-6">
        <p class="block__title">
          <span>6.</span>
          даем реальные навыки в&nbsp;профессии, для&nbsp;составления личных впечатлений
        </p>
      </div>
      <div class="su-career-guidance__block block block-7">
        <p class="block__title">
          <span>7.</span> центр подготовки к&nbsp;поступлению
        </p>

        <ul class="block-7__list">
          <li>усиленно готовим к&nbsp;ОГЭ&nbsp;и&nbsp;ЕГЭ по&nbsp;выбранному направлению</li>
          <li>развиваем не&nbsp;только «харды», но&nbsp;и&nbsp;гибкие навыки</li>
          <li>составляем портфолио для&nbsp;поступления</li>
          <li>даем первые навыки в&nbsp;профессии </li>
        </ul>

        <div class="block-7__statistic">
          <div class="block-7__statistic_image" />
          <div class="block-7__statistic_content">
            <b>куда поступают наши выпускники?</b>
            <p>48,1% поступают в вуз/колледж из топ-20 по России</p>
            <p>11,6% поступают в вуз/колледж зарубеж</p>
            <p>32,4% поступают в остальные вузы/колледжи России</p>

            <span>*статистика поступлений выпускников за&nbsp;22/23 уч. год</span>
          </div>
        </div>
      </div>
      <div class="su-career-guidance__block block block-81">
        <b>81%</b>
        <p class="block-81__title">
          подростков предпочитают получать знания о&nbsp;профессиях еще&nbsp;в&nbsp;школе
        </p>

        <p class="block-81__small">
          *исследование Минпросвещения РФ&nbsp;и&nbsp;Фонд Гуманитарных
          проектов по&nbsp;профориентации за&nbsp;2023&nbsp;год
        </p>
      </div>
      <div class="su-career-guidance__block block block-video">
        <p class="block-video__text">
          как родителю&nbsp;помочь ребенку с&nbsp;выбором&nbsp;профессии?
        </p>

        <button
          class="m-btn"
          @click="openVideoModal('https://www.youtube.com/embed/o8XCGwJo1cQ?si=BqxtT-tQAVVn-Xa-')"
        >
          <img
            src="/v2/school-university/career/video-preview.webp"
            alt="Как помочь ребенку выбрать профессию"
            loading="lazy"
          >
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import scrollTo from '@/utils/scrollTo';

export default {
  name: 'SuCareerGuidance',
  methods: {
    scrollTo,
    ...mapActions('modals', {
      openVideoModal: 'openVideo',
    }),
  },
};
</script>

<style scoped lang="scss">
.su-career-guidance {
  &__content {
    margin-top: 2.5rem;
    display: grid;
    grid-template-columns: repeat(4, calc(25% - (1.25rem * 3) / 4));
    grid-template-rows: repeat(3, 22rem);
    gap: 1.25rem;

    @include media-down($size-tablet) {
      gap: 0.8rem;
      grid-template-rows: repeat(3, 12.8rem) 24rem;
      grid-template-columns: repeat(4, 17.8rem);
    }

    @include media-down($size-mobile) {
      grid-template-columns: repeat(2, 17.9rem);
      grid-template-rows: repeat(4, 12.8rem) 51.2rem 26.4rem;
    }
  }
}

.block {
  display: flex;
  flex-direction: column;
  padding: 1.5rem calc(var(--scale) * 30);

  background-color: #FFFFFF;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 2.5rem;

  @include media-down($size-tablet) {
    padding: 1.2rem 1.2rem 1.2rem 1.6rem;
    background-image: none !important;
  }

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    line-height: 110%;
    color: #02120F;

    @include media-down($size-tablet) {
      font-size: 1.4rem;
      line-height: 130%;
    }

    span {
      color: #FF5319;
    }
  }
}

.block-1 {
  background-image: url("/v2/school-university/career/1.png");

  &__small {
    margin-top: auto;

    font-style: normal;
    font-weight: 400;
    font-size: 1.25rem;
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-weight: 500;
      font-size: 1.4rem;
    }

    br {
      display: none;

      @include media-down($size-tablet) {
        display: block;
      }
    }

    button {
      text-decoration-line: underline;
      color: #5237E6;
      font-size: inherit;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.block-2 {
  background-image: url("/v2/school-university/career/2.png");
}

.block-3 {
  background-image: url("/v2/school-university/career/3.png");
}

.block-4 {
  padding-right: calc(var(--scale) * 18);
  background-image: url("/v2/school-university/career/4.png");

  @include media-down($size-tablet) {
    padding-right: 1.2rem;
  }
}

.block-5 {
  background-image: url("/v2/school-university/career/5.png");
}

.block-6 {
  background-image: url("/v2/school-university/career/6.png");
}

.block-7 {
  grid-column: 3 / 5;
  grid-row: 2 / 4;
  padding-bottom: 2.25rem;
  background-image: url("/v2/school-university/career/7.png");

  @include media-down($size-tablet) {
    grid-row: 2 / 5;
    padding-bottom: 1.6rem;
  }

  @include media-down($size-mobile) {
    grid-column: 1 / 3;
    grid-row: 5 / 6;
  }

  .block__title {
    font-size: 4rem;
    line-height: 95%;
    letter-spacing: -0.02em;

    @include media-down($size-tablet) {
      font-size: 2.8rem;
    }
  }

  &__list {
    margin-top: 1.25rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1.25rem;
    grid-row-gap: 0.5rem;

    @include media-down($size-tablet) {
      grid-template-columns: 1fr;
      grid-gap: 0.8rem;
    }

    li {
      display: flex;
      align-items: center;
      gap: 1.25rem;

      font-size: 1.25rem;
      line-height: 130%;
      color: #02120F;

      @include media-down($size-tablet) {
        gap: 0.8rem;
        font-size: 1.6rem;

        &:nth-of-type(2) {
          order: 3;
        }

        &:nth-of-type(3) {
          order: 2;
        }

        &:nth-of-type(4) {
          order: 4;
        }
      }

      &:before {
        content: '';
        width: 0.75rem;
        aspect-ratio: 1 / 1;
        flex-shrink: 0;
        border-radius: 2px;
        background-color: #02120F;

        @include media-down($size-tablet) {
          width: 1.2rem;
        }
      }
    }
  }

  &__statistic {
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 1.25rem;
    position: relative;

    @include media-down($size-tablet) {
      padding-top: 4rem;
      padding-bottom: 4rem;
      gap: 0.4rem;
    }

    &_image {
      width: calc(var(--scale) * 385);
      height: 100%;
      background-image: url("/v2/school-university/career/statistic.png");
      background-size: contain;
      background-repeat: no-repeat;

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 161);
        background-image: url("/v2/school-university/career/statistic-mob.webp");
      }
    }

    &_content {
      display: flex;
      flex-direction: column;
      gap: 1.25rem;
      max-width: calc(var(--scale) * 385);

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 161);
        padding-top: 1rem;
        gap: 0.8rem;
      }

      @include media-down($size-mobile) {
        padding-top: 1.2rem;
      }

      b {
        max-width: calc(var(--scale) * 310);

        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #02120F;

        @include media-down($size-tablet) {
          max-width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          font-size: 1.8rem;
        }
      }

      p {
        max-width: calc(var(--scale) * 310);

        font-weight: 400;
        font-size: 1.25rem;
        line-height: 130%;
        color: #02120F;

        @include media-down($size-tablet) {
          font-weight: 500;
          font-size: 1.2rem;
        }
      }

      span {
        padding-top: calc(var(--scale) * 30);

        font-style: normal;
        font-weight: 500;
        font-size: calc(var(--scale) * 14);
        line-height: 130%;
        color: #A7ABAC;

        @include media-down($size-tablet) {
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 1.2rem;
        }
      }
    }
  }
}

.block-81 {
  grid-column: 4 / 5;
  grid-row: 1 / 2;
  padding: 0 1.25rem 1.25rem;
  background-image: url("/v2/school-university/career/81.png");

  @include media-down($size-tablet) {
    width: 100%;
    grid-column: 1 / 3;
    grid-row: 3 / 4;
    padding: 1.2rem 1.5rem 1.6rem;

    display: grid;
    grid-template-columns: 1fr 20rem;
    gap: 0.6rem;
  }

  @include media-down($size-mobile) {
    grid-column: 1 / 3;
    grid-row: 3 / 4;
  }

  b {
    font-style: normal;
    font-weight: 500;
    font-size: 7.5rem;
    line-height: 110%;
    letter-spacing: -0.04em;
    color: #5237E6;

    @include media-down($size-tablet) {
      font-size: 6rem;
    }
  }

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #02120F;

    @include media-down($size-tablet) {
      grid-column: 2 / 3;
      font-size: 1.4rem;
      line-height: 130%;
    }
  }

  &__small {
    margin-top: auto;

    font-style: normal;
    font-weight: 500;
    font-size: calc(var(--scale) * 14);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      grid-column: 1 / 3;
      grid-row: 2 / 3;
      margin-top: 0;
      font-size: 1.2rem;
      line-height: 130%;
    }
  }
}

.block-video {
  grid-column: 1 / 2;
  grid-row: 3 / 4;
  padding: 1rem 1.25rem;
  background-image: url("/v2/school-university/career/video.png");

  @include media-down($size-tablet) {
    grid-column: 1 / 3;
    grid-row: 4 / 5;
    padding: 1.2rem 0.8rem 0.8rem;
  }

  @include media-down($size-mobile) {
    grid-column: 1 / 3;
    grid-row: 6 / 7;
  }

  &__text {
    font-style: normal;
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: 1.4rem;
      line-height: 130%;
      padding-inline: 0.8rem;
    }
  }

  button {
    line-height: 0;
    margin-top: auto;
  }

  img {
    width: 100%;

    @include media-down($size-tablet) {
      height: 17rem;
      border-radius: 1.6rem;
      object-fit: cover;
    }

    @include media-down($size-mobile) {
      height: 19.5rem;
    }
  }
}

</style>
